import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { clubQueryKeys } from "./clubQueryKeys";

export function useMutationDeleteCancellationReason({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      params: Parameters<ApiType["clubApi"]["deleteCancellationReason"]>[0],
    ) => api.clubApi.deleteCancellationReason(params),
    onSuccess: async (_, { clubId }) => {
      await queryClient.invalidateQueries({
        queryKey: clubQueryKeys.getCancellationReasonList(clubId),
      });
    },
  });
}
